/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */



app.controller('menue_horizontalMenueMitarbeiter', ['$rootScope', '$scope', '$http','NetworkService', function ($rootScope, $scope, $http, NetworkService) {

        NetworkService.getHighestPermission(function (data) {
            $scope.highestLevel = data.level
        })

        $scope.openEditMode = function ()
        {
            $rootScope.$emit("openEditMode")
        }
        $scope.openNoteAddDialog = function ()
        {
            $("#dialog_createNote").modal("open")()
        }

        $scope.openBlockUserDialog = function ()
        {
            $("#dialog_blockUser").modal("open")()
        }
    }])